import "../styles/page_content.scss";
import "../styles/page_content_mobile.scss";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {useSelector} from "react-redux";
import { selectAdescos, selectCategorie_galerie, selectPhotos, selectSelected_categorie } from "../features/counterSlice";
import {useState,useEffect} from "react";
import {useHistory,useParams,useLocation} from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

const PageContent= ()=>{
	const [data,set_data]=useState(null);

    const {pathname}=useLocation();
	
	useEffect(()=>{
		let url=pathname;
		url=url.split("/");
		console.log(url);
		const type=url[2];
		const id=url[3];
		const target=`https://ongadesco.org/admin/wp-json/wp/v2/${type}/${id}`
		
		fetch(target).then((res)=>{
			return res.json();
		}).then((res)=>{
			set_data(res)
		}).catch((err)=>{
			alert(err.message);
		})
		
	},[])
	
	
	

    return(
        <>
         <Nav no_reload={true}/>
        
        <div className="page_content">
           
		   {data==null && <CircularProgress size={25}/>}
                <div className="content">
                    
				<h2>{data?.title.rendered}</h2>
                <div   dangerouslySetInnerHTML={{__html:data?.acf.details}}/>
                </div>
            <Footer />
        </div>
        </>
    );
}
export default PageContent;